var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 188,
    viewBox: "0 0 210 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.667 19H178L122.667 82.6667L188 169H136.667L96.6667 116.667L50.6667 169H25.3333L84.6667 101L22 19H74.6667L111 67L152.667 19ZM143.667 153.667H157.667L67 33.3333H51.6667L143.667 153.667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon2);
export default __webpack_public_path__ + "static/media/twitter-icon2.cb3ccfdb5660d607b4fd3cad49864c85.svg";
export { ForwardRef as ReactComponent };